<script>
  export let icon;
  export let sprite = "solid";

  let className;

  export { className as class };
</script>

<style>
  svg {
    width: 1.5em;
    height: 1.5em;
  }
</style>

<svg
  width="24"
  height="24"
  fill="currentColor"
  class={className}>
  <use xlink:href="/{sprite}.svg#{icon}" />
</svg>
